import { render } from "./RepairAddForm.vue?vue&type=template&id=e167835e"
import script from "./RepairAddForm.vue?vue&type=script&lang=js"
export * from "./RepairAddForm.vue?vue&type=script&lang=js"

import "./RepairAddForm.vue?vue&type=style&index=0&id=e167835e&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__